import { t as __t } from "i18next";
import React from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";

/**
 * Reusable Confirm Modal (react-bootstrap)
 */
export default function ConfirmModal({
    show,
    onHide,

    title = "Confirm",
    children,

    // buttons
    confirmText = __t("uiText.text008"),
    cancelText = __t("uiText.text016"),
    onConfirm,
    onCancel,

    confirmVariant = "primary",
    cancelVariant = "secondary",

    confirmDisabled = false,
    cancelDisabled = false,
    loading = false,

    // modal behavior
    backdrop = "static", // 'static' | true | false
    keyboard = true,
    centered = true,
    closeButton = true,
    confirmType = "button",

    // size control
    size = "md", // 'sm' | 'lg' | 'xl' | undefined  (react-bootstrap supports sm/lg/xl; md = default)
    fullscreen = false, // true | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down'
    dialogClassName,

    // footer customization
    hideCancel = false,
    hideConfirm = false,
    footer,
}) {
    const handleCancel = () => {
        if (loading) return;
        onCancel?.();
        onHide?.();
    };

    const handleConfirm = async () => {
        if (loading) return;
        await onConfirm?.();
    };

    // react-bootstrap doesn't have "md" size; default is undefined.
    const rbSize = size === "md" ? undefined : size;

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop={backdrop}
            keyboard={keyboard}
            centered={centered}
            size={rbSize}
            fullscreen={fullscreen}
            dialogClassName={dialogClassName}
        >
            <Modal.Header closeButton={closeButton}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleConfirm();
                }}>

                <Modal.Body>{children}</Modal.Body>

                <Modal.Footer>
                    {footer ? (
                        footer
                    ) : (
                        <>
                            {!hideCancel && (
                                <Button
                                    variant={cancelVariant}
                                    onClick={handleCancel}
                                    disabled={cancelDisabled || loading}
                                >
                                    {cancelText}
                                </Button>
                            )}

                            {!hideConfirm && (
                                <Button
                                    type={confirmType}
                                    variant={confirmVariant}
                                    onClick={confirmType === "button" ? handleConfirm : undefined}
                                    disabled={confirmDisabled || loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                className="me-2"
                                            />
                                            {__t("uiText.text017")}</>
                                    ) : (
                                        confirmText
                                    )}
                                </Button>
                            )}
                        </>
                    )}
                </Modal.Footer>
            </Form>
        </Modal>
    );
}